<template>
  <div>
    <v-row class="m-3">
      <v-col cols="12" dir="rtl">
        <div>
          <label for="" style="font-weight: 700">انتخاب حوزه فعالیت *</label>
          <span v-if="categoryId && !showCategoryTable">
            برای تغییر دسته‌بندی، روی آیکون رویرو کلیک کنید.
          </span>
          <v-icon
            large
            class="float-left"
            color="primary"
            @click="showCategoryTable = true"
            v-if="categoryId && !showCategoryTable"
          >
            mdi mdi-chevron-down-circle-outline
          </v-icon>
          <v-icon
            large
            class="float-left"
            color="primary"
            @click="showCategoryTable = false"
            v-else
          >
            mdi mdi-chevron-up-circle-outline
          </v-icon>
        </div>

        <v-data-table
          v-model="selected"
          :single-select="true"
          show-select
          :headers="categoryTableHeaders"
          :items="categoryItems"
          class="elevation-3"
          :items-per-page="10"
          v-if="!categoryId || (categoryId && showCategoryTable)"
        >
          <template v-slot:[`item.data-table-select`]="{ item }">
            <v-checkbox
              @click="selectCategory(item)"
              v-model="selected"
              :value="item"
            ></v-checkbox>
          </template>

          <template v-slot:[`item.categoryName`]="{ item }">
            <span @click="selectCategory(item)" class="table-item-title">{{
              item.categoryName
            }}</span>
          </template>
          <template v-slot:[`item.mainCategoryTitle`]="{ item }">
            <span @click="selectCategory(item)" class="table-item-title">{{
              item.mainCategoryTitle
            }}</span>
          </template>
          <template v-slot:[`item.breadcrumb`]="{ item }">
            <span @click="selectCategory(item)" class="table-item-title">{{
              item.breadcrumb
            }}</span>
          </template>

          <template v-slot:no-data>
            <p>جدول خالی است .</p>
          </template>
        </v-data-table>
      </v-col>
</v-row>
<v-row>
        <v-col cols="12" md="8" v-if="categoryId">
        <label for="" class="mr-5"> حوزه فعالیت انتخاب شده : </label>
        <strong>{{ categorySelctedBreadCrumb }}</strong>
      </v-col>
      <!-- <v-col cols="12" v-if="categoryId">
        <div>
          <v-alert
            v-model="alert"
            border="left"
            close-text="بستن"
            color="primary"
            dark
            dismissible
          >
            دو راه برای ایجاد شناسنامه وجود دارد، ابتدا شناسنامه مورد نظری که
            قصد ایجاد آنرا دارید در جدول زیر جستجو کنید. آنرا مشاهده کنید و در
            صورتیکه مطابق مود نظر شما بود آنرا بعنوان شناسنامه خود انتخاب و
            ادامه دهید تا عملیات ایجاد تکمیل گردد. اگر موردی پیدا نکردید از روی
            دگمه ایجاد شناسنامه(کاتالوگ) آنرا ازابتدا ایجاد کنید.
          </v-alert>
        
        </div>
      </v-col>
      <v-col cols="12" md="4" v-if="categoryId">
        <v-text-field
          outlined
          dense
          clearable
          label="جستجو در نام"
          @input="requestForResults('productNameKeySearchInput', $event)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4" v-if="categoryId">
        <v-text-field
          outlined
          dense
          clearable
          label="جستجو در توضیحات"
          @input="requestForResults('productSummaryKeySearchInput', $event)"
        ></v-text-field>
      </v-col> -->
      <v-col cols="12" md="4" v-if="categoryId">
        <v-btn
          @click="createNewProductWithNoBaseProduct(categoryId)"
          color="primary"
          class="float-left"
        >
          ایجاد شناسنامه (کاتالوگ)
        </v-btn>
      </v-col>
      <!-- <v-col v-if="categoryId" cols="12">
        <v-data-table
          :headers="createProductsHeaders"
          :items="createProductsItems"
          class="elevation-1"
          :items-per-page="10"
        >
          <template v-slot:[`item.defaultImage`]="{ item }">
            <v-img
              @click="selectBaseProductToCreateNewProd(item)"
              class="table-item-title"
              :src="item.defaultImage ? item.defaultImage.thumbnailFileUrl : ''"
              width="80"
              height="45"
              :alt="item.defaultImage ? item.defaultImage.alt : ''"
            ></v-img>
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <span
              @click="selectBaseProductToCreateNewProd(item)"
              class="table-item-title"
              >{{ item.name }}</span
            >
          </template>
          <template v-slot:[`item.summary`]="{ item }">
            <span
              @click="selectBaseProductToCreateNewProd(item)"
              class="table-item-title"
              >{{ item.summary }}</span
            >
          </template>
          <template v-slot:[`item.confirmedSupplierProductsCount`]="{ item }">
            <span>{{ item.confirmedSupplierProductsCount }} </span>
            <v-btn
              icon
              small
              color="primary"
              @click="showSupplierProductsInSite(item)"
              v-if="item.confirmedSupplierProductsCount > 0"
            >
              <v-icon color="blue" small>mdi-web</v-icon></v-btn
            >
          </template>

          <template v-slot:no-data>
            <p>جدول خالی است (لطفا یک پیکربندی انتخاب کنید) .</p>
          </template>
        </v-data-table>
      </v-col> -->
    </v-row>
  </div>
</template>

<script>
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import { RepoFactory } from '@/baseRepository/Factory';
const categoryRepository = RepoFactory.get('category');
const supplierProductRepository = RepoFactory.get('supplierProduct');
import Helper from '@/core/helpers';
import { I } from 'caniuse-lite/data/agents';
export default {
  mixins: [asyncLoadMixin],
  props: {
    categoryType: {
      type: String,
      default: null,
    },
    categoryTypeDisplayName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showCategoryTable: false,
      categoryId: null,
      categorySelctedBreadCrumb: null,
      tooltipProductTable: false,
      tooltipTreeselect: false,
      categoryItems: [],
      createProductsItems: [],
      createProductsHeaders: [
        {
          text: 'عکس پیش فرض',
          align: 'start',
          sortable: true,
          value: 'defaultImage',
        },
        {
          text: 'نام',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'خلاصه',
          align: 'start',
          sortable: true,
          value: 'summary',
        },
        {
          text: 'تعداد محصولات تامین کننده تایید شده',
          align: 'start',
          sortable: true,
          value: 'confirmedSupplierProductsCount',
        },
      ],
      categoryTableHeaders: [
        {
          text: 'نام پیکربندی',
          align: 'start',
          sortable: true,
          value: 'categoryName',
        },
        {
          text: 'نام پیکربندی اصلی',
          align: 'start',
          sortable: true,
          value: 'mainCategoryTitle',
        },
        {
          text: 'مسیر پیکربندی',
          align: 'start',
          sortable: true,
          value: 'breadcrumb',
        },
        {
          text: 'تعداد محصولات تامین کننده',
          align: 'start',
          sortable: true,
          value: 'appliedSupplierProductsCount',
        },
        {
          text: 'تعداد محصولات تامین کننده تایید شده',
          align: 'start',
          sortable: true,
          value: 'confirmedSupplierProductsCount',
        },
      ],
      productNameKeySearch: null,
      productSummaryKeySearch: null,
      selected: [],
      alert:true,
    };
  },
  computed: {
    productBaseUrl() {
      return this.$store.getters.productBaseUrl;
    },
    merchantId() {
      return this.$store.getters.currentMerchant;
    },
  },
  created() {
    this.getMerchantCategoriesBreadCrumb();
  },
  watch: {
    categoryId(after, before) {
      if (after) {
        this.showCategoryTable = false;
        this.getProducts();
      }
    },
    productNameKeySearch(after, before) {
      if (after) {
        this.getProducts();
      } else {
        this.productNameKeySearch = null;
        this.getProducts();
      }
    },
    productSummaryKeySearch(after, before) {
      if (after) {
        this.getProducts();
      } else {
        this.productSummaryKeySearch = null;
        this.getProducts();
      }
    },
  },
  methods: {
    showSupplierProductsInSite(item) {
      let str = item.name.replace(/\s+/g, '-').toLowerCase();
      let pageUrl =
        this.$store.getters.taksaanUrl +
        '/products/base-product/' +
        item.id +
        '/' +
        str;
      window.open(pageUrl, '_blank');
    },
    productNameKeySearchInput(event) {
      this.productNameKeySearch = event;
    },
    productSummaryKeySearchInput(event) {
      this.productSummaryKeySearch = event;
    },
    getProducts() {
      const loader = this.$loading.show();
      this.createProductsItems = [];
      let params = { categoryId: this.categoryId };
      if (this.productNameKeySearch) {
        params.nameKey = this.productNameKeySearch;
      }
      if (this.productSummaryKeySearch) {
        params.summaryKey = this.productSummaryKeySearch;
      }
      supplierProductRepository
        .getProducts(
          this.productBaseUrl,
          {
            MerchantId: this.$store.getters.currentMerchant,
          },
          params
        )
        .then((res) => {
          this.createProductsItems = res.data;
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          Helper.handleErrors(error, this);
        });
    },
    getMerchantCategoriesBreadCrumb() {
      const loader = this.$loading.show();
      this.categoryItems = [];
      let params = {
        categoryTypeItems: this.categoryType,
      };
      categoryRepository
        .getMerchantCategoriesBreadCrumb(
          this.productBaseUrl,
          {
            MerchantId: this.$store.getters.currentMerchant,
          },
          params
        )
        .then((res) => {
          this.categoryItems = res.data;
          if (this.$store.getters.supplierProductIsEdit) {
            this.categoryItems.forEach((categoty) => {
              if (
                categoty.categoryId ==
                this.$store.getters.supplierProductSelectedForEdit.categoryId
              ) {
                this.selectCategory(categoty);
              }
            });
          }
          loader.hide();
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
          loader.hide();
        });
    },
    selectCategory(category) {
      this.selected = [];

      this.selected.push(category);
      this.categoryId = category.categoryId;
      this.categorySelctedBreadCrumb = category.breadcrumb;
      this.$emit(
        'selectCategory',
        category.categoryId,
        this.categorySelctedBreadCrumb
      );
    },
    selectBaseProductToCreateNewProd(product) {
      this.$emit('selectBaseProductToCreateNewProd', product);
    },
    createNewProductWithNoBaseProduct(categoryId) {
      this.$emit('createNewProductWithNoBaseProduct', categoryId);
    },
  },
};
</script>

<style>
.table-item-title {
  cursor: pointer;
}
</style>
